import { GetServerSidePropsContext } from 'next';
import { Institution } from '../Institutions/institution';

export enum Resources {
  eTRF = 'eTRF',
  ordersListView = 'Orders List View',
  kitOrdering = 'Sample Kit Ordering',
  users = 'Users & permissions',
}

export const AUTH_REDIRECT_URL = '/login';
export const RedirectResourceUrls = {
  orders: '/orders',
};

export enum Permissions {
  None = 'None',
  RestrictedReadOnInstitution = 'RestrictedReadOnInstitution',
  ReadOnInstitution = 'ReadOnInstitution', // used for general GET request on an institution specific request
  WriteOnInstitution = 'WriteOnInstitution',
  DeleteOnInstitution = 'DeleteOnInstitution',
  InstitutionAdmin = 'InstitutionAdmin', // All referring to general ability to * resources on all Institutions
  ReadAll = 'ReadAll',
  WriteAll = 'WriteAll',
  DeleteAll = 'DeleteAll',
  AdministrateUsers = 'AdministrateUsers',
  SendReport = 'SendReport',
  ResendReport = 'ResendReport',
  Comment = 'Comment',
  AddendReport = 'AddendReport',
  AccessResults = 'AccessResults', // used for report specific GET request on an institution
  CreateOrder = 'CreateOrder', // used for creation an order through POST
  ChangeOwnSettings = 'ChangeOwnSettings',
  OrderKit = 'OrderKit',
}

export enum UserRole {
  InstitutionUser = 'Institution User',
  OrdersUser = 'Orders User',
  ResultsUser = 'Results User',
}

export type Credentials = {
  email?: string;
  password?: string;
};
export type NextRedirectOptions = {
  ctx: GetServerSidePropsContext;
  resourceName: Resources;
  returnToPath?: string;
  to?: string;
};
export type AuthAndAccessRedirect =
  | {
      redirect: {
        destination: string;
        permanent: boolean;
      };
    }
  | string;

export interface AppUser {
  role: UserRole;
  name: string;
  effectivePermissions: Array<Permissions>;
  email?: string;
  userName?: string;
  gravatarUrl?: string;
  notes?: string;
  institution: Institution;
  lastLogin?: Date;
  numberOfLogins?: number;
  createdAt?: Date;
  modifiedAt?: Date;
  href?: string;
  id?: string;
}

export interface SessionUser extends AppUser {
  access_token?: string;
  refresh_token?: string;
  expires_in?: number;
  isRestricted: boolean;
  canGainAccess: boolean;
}

export type AuthToken = {
  token_type: string;
  expires_in: number;
  access_token: string;
};

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginFormProps {
  loading?: boolean;
  onSubmit: (values: LoginCredentials, showLoginError: (message: any) => void) => void;
}

export const LOGIN_ERROR = 'Wrong email or password.';
